/** @jsx jsx */

import { Spacer, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Button from './Button';
import Page from './Page';

const Styles = {
  root: css`
    text-align: center;
  `,
};

type Props = {
  integrationId: ID;
  name: string;
};

function AlreadyAdminView(props: Props) {
  const { integrationId, name } = props;

  return (
    <Page css={Styles.root}>
      <Text tag="h1" type="SectionHeader">
        You are already an Admin
      </Text>
      <Spacer height={40} />
      <Text tag="p">
        You are an Admin of {name} and have more access than a Collaborator.
      </Text>
      <Spacer height={40} />
      <Button href={`/app/${integrationId}`}>Go to integration</Button>
    </Page>
  );
}

export default AlreadyAdminView;
